'use client'
import React from 'react';
import Image from 'next/image';

const PromoSection = () => {


    const handleScroll = () => {
        const section = document.getElementById("apply");
        section?.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    };

    return (
        <section className="relative w-full h-70 overflow-hidden">
            <Image
                src="https://cdn.msu.edu.in/msu-lP/cook.webp"
                alt="CTA Banner"
                fill
                className="object-cover"
                priority
            />

            <div className="absolute inset-0 bg-[#433500]/50" />

            <div className="relative z-10 flex h-full flex-col items-center justify-center text-center px-4">
                <h2 className="text-white text-3xl md:text-4xl lg:text-5xl font-bold">
                    Don&apos;t Wait! Grab Your Seat Now!
                </h2>

                <p className="mt-3 text-white/90 text-sm md:text-lg">
                    Take the First Step Toward a Bright Future with MSU
                </p>

                <button
                    onClick={handleScroll}
                    className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#F5A400] px-8 py-3 text-sm font-semibold text-black transition-all duration-300 hover:scale-105 hover:bg-[#ffb51f]"
                >
                    APPLY NOW
                    <span>↗</span>
                </button>
            </div>
        </section>
    )
}

export default PromoSection